import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {AuthService} from "../security/auth.service";
import {Router, ActivatedRoute} from "@angular/router";
import {validateEmail} from "../validators/validate-email";
import {AuthInfo} from "../security/auth-info";
import {Overlay} from "angular2-modal";
import {Modal} from "angular2-modal/plugins/bootstrap";



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {

  authInfo:AuthInfo;

  form:FormGroup;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route:ActivatedRoute,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,

  )
  {
    this.form = this.fb.group({
      email:['',[Validators.required, validateEmail]],
      password:['',Validators.required]
    });

    overlay.defaultViewContainer = vcRef;


  }

  ngOnInit() {


    this.authService.authInto$
      .subscribe(authInfo => this.authInfo = authInfo);

    // this.messageTitle = "Loading ...";
    // this.messageBody = "Please press ok and try again ...";


     // this.form.controls['email'].setValue("dies@luissalcedo.com");
     // this.form.controls['password'].setValue("password2");



    if (this.authInfo.$uid) {
      if(!this.authInfo.isVerified()){
        this.showemailVerificationMessage()
      }
    }

  }


    showemailVerificationMessage(){
      this.messageIt('Verify your email','You must verify your Email address to gain full access to the site!');
    }


/*
  sendVerificationEmail(){
    const sendEmail$ = this.authService.sendVerificationEmmail()
    sendEmail$.subscribe(
      () => {
        this.messageIt('Email Vefirication','Your email verification have been send!')
      },
      err => this.messageIt('Eamil Verofocation Error', err)
    )
  }
*/


  login(){
 const formValue = this.form.value;
 const login$ = this.authService.login(formValue.email, formValue.password)
    login$.subscribe(
      () => {
        this.verifyAndNavigate();
      //          TODO : Route to Main authorized page
            },err => {
                        this.messageIt('Login Error',err)
                    }
    )

  }


/*
  login(){
    const formValue = this.form.value;
    const loginIn$ = this.authService.login(formValue.email, formValue.password);
    loginIn$.subscribe(
        () => {
        },
        Error => this.messageIt('Login Error', Error)
      )
  }
*/



  sendResetPassword(){
    const formValue = this.form.value;
    const emailReset$ =  this.authService.resetPassword(formValue.email);
    emailReset$.subscribe(
      () =>  {
        this.messageIt('Password Reset','Password Reset Email sent successfully! Please check your Inbox for a Reset Email.');
      },
      Error => this.messageIt('Password Reset', Error)
    )
  }




  itHaveErrors(){
    return this.form.valid;
  }

  isErrorVisible(field:string,error:string){
    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];
  }

  isEmailValid():boolean{
    return !this.form.controls['email'].errors
  }


  resendVerification(){
    // console.log("Resending Verification");
    const emailVerification$ = this.authService.sendVerificationEmmail();
    emailVerification$.subscribe(
      ()=>{},
      err => this.messageIt('Password verification',err)
    )
    this.emailSentDialog();
  }


  openModal(){
    this.messageIt('Modal Test','Test successfully! ');
  }

  messageIt(titleP:string,messageP:string){
    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }


  private verifyAndNavigate() {
    if(!this.authService.emailVerified()){
      // this.authService.logout();
      this.resendDialog();
    } else {
        this.router.navigate(['/restaurants']);
      }
  }


  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
  }


  showEmailErrors(){
    if (this.form.controls['email'].errors){
        this.form.controls['email'].markAsDirty();
      }

  }

  resendDialog(){
    this.modal.confirm()
      .size('lg')

      .isBlocking(true)
      .showClose(true)
      .keyboard(27)
      .title('Verify your email')
      .body('<p>You must verify your Email address to gain full access to all system!</p> Please check your Mailbox for a Verification mail from SRVPLS !')
      .okBtn('Resend Confirmation Email')
      .cancelBtn('Ok')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => { this.resendVerification();this._cleanup()})
      .catch((err: any) => this._cleanup())

    ;
  }



 emailSentDialog(){
    this.modal.alert()
      .size('lg')
      .isBlocking(true)
      .showClose(true)
      .keyboard(27)
      .title('Verify your email')
      .body('Please check your Mailbox for a Verification mail from SRVPLS !')
      .okBtn('OK')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => { this._cleanup()})
    // .catch((err: any) => this._cleanup())

    ;
  }

  _cleanup(){
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/login/login.component.ts